import { Component, OnInit } from '@angular/core';
import {
  IconEnum,
  ControlSizeEnum,
  ControlTypeColorEnum,
  AvatarTypeEnum,
  DialogRef
} from 'datnek-ds';

@Component({
  selector: 'nk-shared-dialog-share-screen',
  templateUrl: './dialog-share-screen.component.html',
  styleUrls: ['./dialog-share-screen.component.scss'],
})
export class DialogShareScreenComponent implements OnInit {
  iconEnum = IconEnum;
  sizeEnum = ControlSizeEnum;
  colorEnum = ControlTypeColorEnum;
  avatarEnum = AvatarTypeEnum;

  constructor(public dialogRef: DialogRef) {}

  ngOnInit(): void {}
}
